import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { FloatingReviews } from "./FloatingReviews";
import { MobileStickyContact } from "./MobileStickyContact";
import { PromoBar } from "./PromoBar";

export const PageLayout = ({ children, hidePromo = false }) => (
  <div className="min-h-screen bg-white flex flex-col">
    {!hidePromo && <PromoBar />}
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppFloat />
    <FloatingReviews />
    <MobileStickyContact />
  </div>
);
